import { Box, Button, Container, Grid, Typography, Card, CardContent, TextField, Avatar } from "@mui/material";
import { DashboardLayout } from "../../components/dashboard-layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../theme";
import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import PhoneIcon from '@mui/icons-material/Phone';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import LockIcon from '@mui/icons-material/Lock';
import KeyIcon from '@mui/icons-material/Key';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

export default function AccountProfile() {
    const [profile, setProfile] = useState(null);
    const [bank, setBank] = useState(null);
    const [load, setLoad] = useState(false);

    useEffect(() => {
        axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) config.headers["Authorization"] = `Bearer ${token}`;
                return config;
            }
        );

        axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`)
            .then((res) => {
                setProfile(res.data.data);
                if (res.data.data?._id) {
                    axios.post(`${process.env.REACT_APP_API_URL}/bank/getBankUser`, { id: res.data.data._id })
                        .then((resBank) => {
                            setBank(resBank.data.data);
                            setLoad(true);
                        }).catch(() => setBank(null));
                }
            })
            .catch(() => setProfile(null));
    }, [load]);

    const [openBank, setOpenBank] = useState(false);
    const [bankName, setBankName] = useState("");
    const [bankAccount, setBankAccount] = useState("");
    const [bankOwner, setBankOwner] = useState("");

    const addBank = () => {
        setOpenBank(true);
    };

    const handleAddBank = () => {
        if (!bankName || !bankAccount || !bankOwner) {
            swal("Lỗi", "Vui lòng nhập đầy đủ thông tin", "error");
            return;
        }
        axios.post(`${process.env.REACT_APP_API_URL}/bank/create`, {
            name_bank: bankName,
            stk: bankAccount,
            fullname: bankOwner
        })
        .then((res) => {
            if (res.data.success) {
                swal("Thành công", "Đã thêm ngân hàng thành công", "success");
                setOpenBank(false);
                setLoad(!load);
            } else {
                swal("Lỗi", res.data.message || "Thêm thất bại", "error");
            }
        })
        .catch((err) => {
            swal("Lỗi", "Đã có lỗi xảy ra", "error");
        });
    };

    const changePassword = () => {
        swal("Thông báo", "Vui lòng liên hệ bộ phận CSKH để hỗ trợ đổi mật khẩu.", "info");
    };

    return (
        <ThemeProvider theme={theme}>
            <DashboardLayout customer={true}>
                <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
                    <Container maxWidth={false}>
                        <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', backgroundColor: '#fff', p: 3, borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                            <Avatar sx={{ width: 80, height: 80, backgroundColor: '#3b82f6', fontSize: '32px', mr: 3 }}>
                                {profile?.username?.charAt(0).toUpperCase() || 'D'}
                            </Avatar>
                            <Box>
                                <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1f2937' }}>Thông tin tài khoản</Typography>
                                <Typography variant="body1" sx={{ color: '#6b7280' }}>Quản lý thông tin cá nhân và bảo mật tài khoản</Typography>
                            </Box>
                        </Box>

                        <Grid container spacing={3}>
                            {/* Thông tin cá nhân */}
                            <Grid item xs={12} md={4}>
                                <Card sx={{ height: '100%', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                                    <CardContent>
                                        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 3, fontWeight: 'bold' }}>
                                            <Avatar sx={{ width: 32, height: 32, backgroundColor: '#e0e7ff', color: '#4f46e5', mr: 2 }}>
                                                <i className="fa-solid fa-user" style={{ fontSize: '14px' }}></i>
                                            </Avatar>
                                            Thông tin cá nhân
                                        </Typography>
                                        
                                        <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', mb: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748b' }}>Tài khoản</Typography>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{profile?.username || '...'}</Typography>
                                        </Box>
                                        
                                        <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', mb: 2 }}>
                                            <Typography variant="caption" sx={{ color: '#64748b' }}>Họ và tên</Typography>
                                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{profile?.name || 'Chưa cập nhật'}</Typography>
                                        </Box>
                                        
                                        <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', mb: 2, display: 'flex', alignItems: 'center' }}>
                                            <PhoneIcon sx={{ color: '#22c55e', mr: 2 }} />
                                            <Box>
                                                <Typography variant="caption" sx={{ color: '#64748b' }}>Số điện thoại</Typography>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{profile?.sdt || 'Chưa cập nhật'}</Typography>
                                            </Box>
                                        </Box>

                                        <Box sx={{ backgroundColor: '#f0fdf4', p: 2, borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', border: '1px solid #bbf7d0' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <AccountBalanceWalletIcon sx={{ color: '#16a34a', mr: 2 }} />
                                                <Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b' }}>Số dư</Typography>
                                                    <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#16a34a' }}>
                                                        {profile?.money?.toLocaleString('vi-VN') || 0}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            <Box sx={{ backgroundColor: '#dcfce7', color: '#16a34a', px: 1.5, py: 0.5, borderRadius: '12px', fontSize: '12px', fontWeight: 'bold' }}>
                                                <i className="fa-solid fa-check-circle" style={{marginRight: '4px'}}></i> Hoạt động
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* Bảo mật tài khoản */}
                            <Grid item xs={12} md={4}>
                                <Card sx={{ height: '100%', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                                    <CardContent>
                                        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 3, fontWeight: 'bold' }}>
                                            <Avatar sx={{ width: 32, height: 32, backgroundColor: '#ffedd5', color: '#ea580c', mr: 2 }}>
                                                <i className="fa-solid fa-shield-halved" style={{ fontSize: '14px' }}></i>
                                            </Avatar>
                                            Bảo mật tài khoản
                                        </Typography>

                                        <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <LockIcon sx={{ color: '#ef4444', mr: 2 }} />
                                                <Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b' }}>Mật khẩu đăng nhập</Typography>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>**********</Typography>
                                                </Box>
                                            </Box>
                                            <Button variant="contained" size="small" sx={{ backgroundColor: '#3b82f6', textTransform: 'none' }} onClick={changePassword}>
                                                Thay đổi
                                            </Button>
                                        </Box>

                                        <Box sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <KeyIcon sx={{ color: '#a855f7', mr: 2 }} />
                                                <Box>
                                                    <Typography variant="caption" sx={{ color: '#64748b' }}>Mật khẩu rút tiền</Typography>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>**********</Typography>
                                                </Box>
                                            </Box>
                                            <Button variant="contained" size="small" sx={{ backgroundColor: '#3b82f6', textTransform: 'none' }} onClick={changePassword}>
                                                Thay đổi
                                            </Button>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </Grid>

                            {/* Ngân hàng */}
                            <Grid item xs={12} md={4}>
                                <Card sx={{ height: '100%', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.05)' }}>
                                    <CardContent sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', mb: 3, fontWeight: 'bold' }}>
                                            <Avatar sx={{ width: 32, height: 32, backgroundColor: '#e0e7ff', color: '#4f46e5', mr: 2 }}>
                                                <AccountBalanceIcon sx={{ fontSize: '18px' }} />
                                            </Avatar>
                                            Ngân hàng
                                        </Typography>

                                        {bank && bank.length > 0 ? (
                                            <Box>
                                                {bank.map((b, idx) => (
                                                    <Box key={idx} sx={{ backgroundColor: '#f8fafc', p: 2, borderRadius: '8px', mb: 2 }}>
                                                        <Typography variant="caption" sx={{ color: '#64748b' }}>Ngân hàng</Typography>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{b.name_bank}</Typography>
                                                        
                                                        <Typography variant="caption" sx={{ color: '#64748b', mt: 1, display: 'block' }}>Chủ tài khoản</Typography>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{b.fullname || b.name_user}</Typography>

                                                        <Typography variant="caption" sx={{ color: '#64748b', mt: 1, display: 'block' }}>Số tài khoản</Typography>
                                                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#334155' }}>{b.stk}</Typography>
                                                    </Box>
                                                ))}
                                            </Box>
                                        ) : (
                                            <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', py: 4 }}>
                                                <Avatar sx={{ width: 48, height: 48, backgroundColor: '#fef3c7', color: '#d97706', mb: 2 }}>
                                                    <i className="fa-solid fa-triangle-exclamation"></i>
                                                </Avatar>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1, color: '#334155' }}>Bạn chưa có tài khoản ngân hàng</Typography>
                                                <Typography variant="body2" sx={{ mb: 3, color: '#64748b' }}>
                                                    Vui lòng liên hệ CSKH hoặc Admin để thêm thông tin ngân hàng rút tiền
                                                </Typography>
                                                <Button variant="contained" sx={{ backgroundColor: '#3b82f6', textTransform: 'none', px: 3, borderRadius: '20px' }} onClick={addBank}>
                                                    + Thêm ngân hàng
                                                </Button>
                                            </Box>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </Container>
                </Box>
            </DashboardLayout>
            <Dialog open={openBank} onClose={() => setOpenBank(false)} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: '12px' } }}>
                <DialogTitle sx={{ fontWeight: 'bold', borderBottom: '1px solid #e2e8f0', pb: 2 }}>
                    Thêm tài khoản ngân hàng
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ pt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel shrink sx={{ backgroundColor: '#fff', px: 0.5 }}>Tên Ngân hàng</InputLabel>
                            <Select
                                value={bankName}
                                label="Tên Ngân hàng"
                                onChange={(e) => setBankName(e.target.value)}
                            >
                                <MenuItem value=""><em>-- Chọn ngân hàng --</em></MenuItem>
                                <MenuItem value="ABBANK (ABB)">ABBANK (ABB)</MenuItem>
                                <MenuItem value="ACB (ACB)">ACB (ACB)</MenuItem>
                                <MenuItem value="Agribank (AGR)">Agribank (AGR)</MenuItem>
                                <MenuItem value="Bac A Bank (BAB)">Bac A Bank (BAB)</MenuItem>
                                <MenuItem value="BanVietBank (VCCB)">BanVietBank (VCCB)</MenuItem>
                                <MenuItem value="Bao Viet Bank (BVB)">Bao Viet Bank (BVB)</MenuItem>
                                <MenuItem value="BIDV (BIDV)">BIDV (BIDV)</MenuItem>
                                <MenuItem value="Cake by VPBank (CAKE)">Cake by VPBank (CAKE)</MenuItem>
                                <MenuItem value="Dong A Bank (DAB)">Dong A Bank (DAB)</MenuItem>
                                <MenuItem value="Eximbank (EIB)">Eximbank (EIB)</MenuItem>
                                <MenuItem value="HD Bank (HDB)">HD Bank (HDB)</MenuItem>
                                <MenuItem value="KienLong Bank (KLB)">KienLong Bank (KLB)</MenuItem>
                                <MenuItem value="LienVietPostBank (LPB)">LienVietPostBank (LPB)</MenuItem>
                                <MenuItem value="Maritime Bank (MSB)">Maritime Bank (MSB)</MenuItem>
                                <MenuItem value="MB BANK (MBB)">MB BANK (MBB)</MenuItem>
                                <MenuItem value="Nam A Bank (NAB)">Nam A Bank (NAB)</MenuItem>
                                <MenuItem value="Orient Commercial Bank (OCB)">Orient Commercial Bank (OCB)</MenuItem>
                                <MenuItem value="PG Bank (PGB)">PG Bank (PGB)</MenuItem>
                                <MenuItem value="PVComBank (PVC)">PVComBank (PVC)</MenuItem>
                                <MenuItem value="Sacombank (STB)">Sacombank (STB)</MenuItem>
                                <MenuItem value="Sai Gon Commercial Bank (SCB)">Sai Gon Commercial Bank (SCB)</MenuItem>
                                <MenuItem value="Saigonbank (SGB)">Saigonbank (SGB)</MenuItem>
                                <MenuItem value="SeaBank (SEAB)">SeaBank (SEAB)</MenuItem>
                                <MenuItem value="SHB Bank (SHB)">SHB Bank (SHB)</MenuItem>
                                <MenuItem value="Shinhan Bank VN (SHBVN)">Shinhan Bank VN (SHBVN)</MenuItem>
                                <MenuItem value="Techcombank (TCB)">Techcombank (TCB)</MenuItem>
                                <MenuItem value="TienPhong Bank (TPB)">TienPhong Bank (TPB)</MenuItem>
                                <MenuItem value="VIB (VIB)">VIB (VIB)</MenuItem>
                                <MenuItem value="VietBank (VBB)">VietBank (VBB)</MenuItem>
                                <MenuItem value="Vietcombank (VCB)">Vietcombank (VCB)</MenuItem>
                                <MenuItem value="Vietinbank (VTB)">Vietinbank (VTB)</MenuItem>
                                <MenuItem value="VP Bank (VPB)">VP Bank (VPB)</MenuItem>
                            </Select>
                        </FormControl>
                        <TextField 
                            label="Tên chủ tài khoản (Viết hoa không dấu)" 
                            fullWidth 
                            variant="outlined"
                            InputLabelProps={{ shrink: true, sx: { backgroundColor: '#fff', px: 0.5 } }}
                            value={bankOwner}
                            onChange={(e) => setBankOwner(e.target.value.toUpperCase())}
                        />
                        <TextField 
                            label="Số tài khoản" 
                            fullWidth 
                            variant="outlined"
                            InputLabelProps={{ shrink: true, sx: { backgroundColor: '#fff', px: 0.5 } }}
                            type="number"
                            value={bankAccount}
                            onChange={(e) => setBankAccount(e.target.value)}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 0, borderTop: '1px solid #e2e8f0', mt: 1 }}>
                    <Button onClick={() => setOpenBank(false)} sx={{ color: '#64748b' }}>Hủy</Button>
                    <Button variant="contained" onClick={handleAddBank} sx={{ backgroundColor: '#3b82f6', textTransform: 'none', px: 4, borderRadius: '8px' }}>
                        Xác nhận
                    </Button>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}
